import { toolSideKey } from '@/types/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SideState {
  activeToolSide: string | null;
  toolSideData: any;
  style?: any;
}

const initialState: SideState = {
  activeToolSide: null,
  toolSideData: null,
};

const toolSideSlice = createSlice({
  name: 'toolSide',
  initialState,
  reducers: {
    showToolSide: (
      state,
      action: PayloadAction<{
        sideKey: toolSideKey;
        sideData?: any;
      }>
    ) => {
      state.activeToolSide = action.payload.sideKey;
      state.toolSideData = action.payload.sideData || null;
    },
    hideToolSide: (state) => {
      state.activeToolSide = null;
      state.toolSideData = null;
    },
    resetToolSide: (state) => {
      state.activeToolSide = null;
      state.toolSideData = null;
    },
    updateData: (
      state,
      action: PayloadAction<{
        key: string;
        value: any;
        [key: string]: any;
      }>
    ) => {
      if (state.toolSideData) {
        state.toolSideData[action.payload.key] = action.payload.value;
      }
    },
  },
});

export const { showToolSide, hideToolSide, resetToolSide, updateData } =
  toolSideSlice.actions;

export default toolSideSlice.reducer;
